import { render, staticRenderFns } from "./SpendeappEmbed.vue?vue&type=template&id=1dff12e1&"
import script from "./SpendeappEmbed.vue?vue&type=script&lang=js&"
export * from "./SpendeappEmbed.vue?vue&type=script&lang=js&"
import style0 from "./SpendeappEmbed.vue?vue&type=style&index=0&id=1dff12e1&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports